
@switch (layout) {
  @case ('standard') {
    <mat-card
      class="display-ad">
      @if (promotion.imageUrl) {
        <div
          class="image-container">
          <img [src]="promotion.imageUrl"
            class="promotion-image"
            mat-card-image/>
        </div>
      }
      <mat-card-content class="promotion-header">
        @if (promotion.advertiser.logo) {
          <img
            [src]="promotion.advertiser.logo"
            class="advertiser-logo"/>
        }
        <div class="promotion-text">
          <h3 class="promotion-title">{{promotion.title}}</h3>
          <p class="promotion-description">{{promotion.description}}</p>
        </div>
      </mat-card-content>
      <mat-card-actions class="promotion-actions">
        <small class="sponsored">SPONSORED</small>
        @if (hasExternalUrl) {
          <a (click)="onTriggerAction()"
            [href]="routeUrl"
            class="button"
            color="accent"
            mat-button
            target="_blank">
            View
          </a>
        } @else {
          <a mat-button
            (click)="onTriggerAction()"
            [routerLink]="routeUrl"
            class="button"
            color="accent">
            View
          </a>
        }
      </mat-card-actions>
    </mat-card>
  }
  @case ('list') {
    <mat-card
      [class.column]="shouldBreakToColumn"
      class="display-ad list-item">
      @if (promotion.imageUrl) {
        <div
          class="image-container">
          <img [src]="promotion.imageUrl"
            class="promotion-image"/>
        </div>
      }
      <div class="promotion-content">
        <div class="promotion-header">
          @if (promotion.advertiser.logo) {
            <img
              [src]="promotion.advertiser.logo"
              class="advertiser-logo"/>
          }
          <div class="promotion-text">
            <h3 class="promotion-title">{{promotion.title}}</h3>
            <p class="promotion-description">{{promotion.description}}</p>
          </div>
        </div>
        <div class="promotion-actions">
          <small class="sponsored">SPONSORED</small>
          @if (hasExternalUrl) {
            <a (click)="onTriggerAction()"
              [href]="routeUrl"
              class="button"
              color="accent"
              mat-button
              target="_blank">
              View
            </a>
          } @else {
            <a mat-button
              (click)="onTriggerAction()"
              [routerLink]="routeUrl"
              class="button"
              color="accent">
              View
            </a>
          }
        </div>
      </div>
    </mat-card>
  }
}

